import {
  getFilterIcon
} from '../../common/filter-mode';

require('./dashboard-node.component.scss');

class DashboardNodeController {
  constructor(
    $scope,
    $element,
    $timeout,
    $q,
    CurrentFilterService,
    CurrentFilterDataService,
    PermissionService,
    LayoutService,
    RouterService,
    FilterDataFactory,
    FilterEditorService,
    FiltersService,
    $window,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$window = $window;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.FilterEditorService = FilterEditorService;
    this.FiltersService = FiltersService;
    if (!CurrentFilterDataService.dashboardData) CurrentFilterDataService.dashboardData = {};
    this.dashboardData = CurrentFilterDataService.dashboardData;
    // this.filterData = FilterDataFactory();
    this.FilterDataFactory = FilterDataFactory;
    this.reportsHeightAttepmpts = 0;
    // console.log('new node');
  }

  get isCardOrDashboard() {
    return this._filter.isDashboard || this._filter.isCard;
  }

  get isInCard() {
    return this.CurrentFilterService.filter.isCard;
  }

  get filter() {
    return this._filter;
  }

  get filterIcon() {
    if (!this.filter) return '';
    // if (this.filter.children.length) return this.minimized ? 'icon-vcard' : 'icon-folder-open-empty';
    if (this.filter && this.filter.children && this.filter.children.length) return 'icon-vcard';
    return getFilterIcon(this.filter);
  }

  saveAsPicture() {
    this.layout.saveAsPicture(this.dashboardData[this.filter.dIndex],
      message => {
        this.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка при получении изображения'), message, null, true);
      }, this.$element[0]);
  }

  editFilter() {
    this.router.isEditDasboard = true;
    const filter = this.filter;
    return this.$q.resolve()
      .then(() => {
        return this.FilterEditorService.editModal({
          filter,
          asNew: false,
          selectFilter: false,
        });
      })
      .then(resFilter => {
        this.router.isEditDasboard = false;
        if (!resFilter) return;
        this.filter = resFilter;
        const index = this.dashboard.filter.children.findIndex(f => resFilter.dIndex === f.dIndex);
        if (index == -1) {
          this.dashboard.filter.children.push(resFilter);
        } else {
          this.dashboard.filter.children[index] = resFilter;
        }
        if (!resFilter.deleted) {
          this.dashboardData[this.filter.dIndex].update(this.filter);
        } else {
          delete this.dashboardData[this.filter.dIndex];
        }
        this.setRouterFilter();
      });
  }


  get canChange() {
    return this.CurrentFilterService.filter && this.dashboard && this.dashboard.filter &&
      this.CurrentFilterService.filter.id === this.dashboard.filter.id;
  }

  setRouterFilter() {
    this.router.filterChanged();
  }

  setFilter(filter) {
    // console.log('setFilter', filter.id, filter.name);
    if (filter.id && filter.dIndex && `${filter.id}` != filter.dIndex && !filter.deleted) {
      this.dashboardData[filter.id] = this.dashboardData[filter.dIndex];
      // this.dashboardData[this.filter.id].update(this.filter);
      const dIndex = filter.dIndex;
      this.$timeout(() => {
        delete this.dashboardData[dIndex];
      }, 500);
    }

    if (filter.id) filter.dIndex = `${filter.id}`;
    if (!filter.dIndex || !this._filter) {
      if (!filter.dIndex) {
        this.dashboard.currentDIndex += 1;
        filter.dIndex = `${this.dashboard.filter.id}_${this.dashboard.currentDIndex}`;
        // console.log('установлен индекс:', filter.id, filter.dIndex);
      }
      this._filter = filter;
      if (!this.minimized) this.filterDataUpdate();
      this.setRouterFilter();
    } else {
      this._filter = filter;
      if (!this.minimized) this.filterDataUpdate();
    }
  }

  set filter(filter) {
    if (!filter) return;
    // if (this.dashboard) this.setFilter(filter);
    this.$timeout(() => {
      this.setFilter(filter);
    }, 0);
  }

  filterDataUpdate() {
    if (this.filter.deleted) return;
    this.$timeout(() => {
      if (!this.filter.id && !this.filter.dIndex) return;
      if (this.filter.dIndex && !this.dashboardData[this.filter.dIndex]) {
        this.dashboardData[this.filter.dIndex] = this.FilterDataFactory();
      }
      if (this.filter.id && this.filter.dIndex && !this.dashboardData[this.filter.id] &&
        this.dashboardData[this.filter.dIndex]) {
        this.dashboardData[this.filter.id] = this.dashboardData[this.filter.dIndex];
        const dIndex = this.filter.dIndex;
        this.$timeout(() => delete this.dashboardData[dIndex], 500);
        this.filter.dIndex = `${this.filter.id}`;
      }
      if (!this.filter.dIndex && this.filter.id) {
        this.filter.dIndex = this.filter.id;
      }
      if ((this.filter.isChanged || !this.dashboardData[this.filter.dIndex].filter) &&
        this.filter.dIndex && this.dashboardData[this.filter.dIndex]) {
        this.dashboardData[this.filter.dIndex]
          .update(this.dashboard.filter.isDashboard ? this.dashboardData[this.filter.dIndex].filter : this.filter);
        // console.log('загрузка данных:', this.filter.id, this.filter.name, this.filter.dIndex);
      }
    }, 100);
  }

  set minimized(minimized) {
    if (this.canChange) {
      this.filter.cardMinimazed = minimized;
      if (!minimized) this.filterDataUpdate();
      this.setRouterFilter();
    }
  }

  get minimized() {
    return !!this.filter.cardMinimazed;
  }

  toggleMinimized() {
    this.minimized = !this.minimized;
  }

  getViewHeight() {
    const svg = this.$element.find('svg');
    let minHeight = 0;
    svg.each(i => {
      const h = $(svg[i]).height();
      if (minHeight < h) minHeight = h;
    });
    this.height = this.dashboard.getHeightPx(this.filter, this.minimized, minHeight + 82);

    if (!this.height) {
      if (this.filter.isReports && this.reportsHeightAttepmpts < 5000) {
        this.$timeout(() => {
          if (this.height) return;
          let el = null;
          this.reportsHeightAttepmpts += 1;
          try {
            el = this.$element.find('iframe').contents().find('body');
          } catch (e) {
            el = null;
          }

          if (el && el.height() && el.find('#_ReportHeader').length) {
            this.height = el.height();
            this.filter.cardHeight = 1;
            const height1 = this.dashboard.getHeightPx(this.filter, this.minimized, minHeight + 82);
            this.filter.cardHeight = Math.ceil(this.height / height1);
          }
        }, 500);
        if (!this.height) return 'auto';
      } else return 'auto';
    }
    this.height -= this.$element.find('h4').outerHeight(true);
    return (this.height < 0 ? 0 : this.height) + 'px';
  }
}

export const DashboardNodeComponent = {
  template: require('./dashboard-node.component.html'),
  require: {
    dashboard: '^scDashboard'
  },
  bindings: {
    filter: '<',
  },
  controller: DashboardNodeController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/dashboard-node.component.js